<!-- Page Title -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content text-white">
                    <h2>Datenschutzerklärung</h2>
                    <ul class="text-gray-200">
                        <li><a routerLink="/" class="hover:underline">Home</a></li>
                        <li>Datenschutz</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Datenschutz Content -->
<section class="py-20 bg-white">
    <div class="container mx-auto px-4 max-w-4xl text-gray-800">
        <h2 class="text-3xl font-bold mb-6">Datenschutzerklärung</h2>

        <h3 class="text-xl font-semibold mt-6 mb-2">Grundsatz</h3>
        <p class="mb-4">
            Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. HIGETO e.V. verpflichtet sich,
            Ihre Privatsphäre zu schützen und Ihre Daten vertraulich zu behandeln. Unsere Datenschutzpraktiken
            stehen im Einklang mit dem Bundesdatenschutzgesetz (BDSG), der Datenschutz-Grundverordnung der EU (DSGVO)
            und dieser Datenschutzerklärung.
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-2">Erhebung und Verarbeitung persönlicher Daten</h3>
        <p class="mb-4">
            Beim Besuch unserer Website werden allgemeine Informationen wie Datum und Dauer des Besuchs, Browsertyp
            und die genutzte IP-Adresse nur zum Zwecke der Systemverwaltung, statistischen Auswertung und Sicherheit
            erfasst. Diese Daten werden nicht mit personenbezogenen Informationen verknüpft.
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-2">Externes Hosting</h3>
        <p class="mb-4">
            HIGETO e.V. nutzt die Dienste eines externen Hosting-Anbieters, um unsere Website auf Servern in Deutschland
            zu betreiben. Die auf unserer Website erfassten personenbezogenen Daten werden dort gespeichert. Die Wahl
            eines professionellen Hosters dient der sicheren, schnellen und zuverlässigen Bereitstellung unseres
            Online-Angebots gemäß Art. 6 Abs. 1 lit. f DSGVO.
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-2">Nutzungsdaten</h3>
        <p class="mb-4">
            Beim Besuch unserer Website werden allgemeine Informationen wie Datum und Dauer des Besuchs, Browsertyp
            und IP-Adresse zu System- und Sicherheitszwecken erfasst – ohne Verknüpfung zu persönlichen Daten.
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-2">Weitergabe an Dritte</h3>
        <p class="mb-4">
            Eine Weitergabe Ihrer persönlichen Daten an Dritte erfolgt nicht ohne Ihre ausdrückliche Einwilligung,
            es sei denn, wir sind gesetzlich dazu verpflichtet.
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-2">Cookies und Web-Tracking</h3>
        <p class="mb-4">
            Unsere Website verwendet keine Cookies und betreibt kein Web-Tracking.
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-2">Datensicherheit</h3>
        <p class="mb-4">
            Wir treffen technische und organisatorische Sicherheitsmaßnahmen, um Ihre Daten gegen Manipulation, Verlust,
            Zerstörung oder unbefugten Zugriff zu schützen.
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-2">Ihre Rechte</h3>
        <p class="mb-4">
            Sie haben das Recht auf Auskunft über die bei uns gespeicherten personenbezogenen Daten sowie auf
            Berichtigung, Löschung oder Einschränkung der Verarbeitung. Sie können außerdem der Verarbeitung
            widersprechen und haben ein Recht auf Datenübertragbarkeit.
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-2">Änderungen dieser Datenschutzerklärung</h3>
        <p class="mb-4">
            Wir behalten uns vor, diese Erklärung an veränderte rechtliche Rahmenbedingungen oder technische Änderungen
            unseres Angebots anzupassen.
        </p>

        <p class="text-sm text-gray-500">Letzte Aktualisierung: 20.04.2025</p>
    </div>
</section>
